<template>
    <!-- contents -->
    <div id="contents">
        <div class="contents_wrap">
            <!-- contents_head -->
            <h2 class="pg_title">Service Bulletin - Mobile (English) Edit</h2>
            <div class="bc_ico">
                Home
                <em>
                    <span class="sr_only">&gt;</span>
                </em> Engineer
                <em>
                    <span class="sr_only">&gt;</span>
                </em> Service Bulletin
                <em>
                    <span class="sr_only">&gt;</span>
                </em> Mobile (English) Edit
            </div>
            <!-- <skp-breadcrumbs @page-title="val => (pageTitle = val)" /> -->
            <!-- //contents_head -->
            <!-- detail_f tit -->
            <div class="sub_tit">Basic Info.</div>
            <!-- //detail_f tit -->
            <!-- detail_f -->
            <table class="create_table">
                <colgroup>
                    <col width="15%" />
                    <col width="*" />
                    <col width="15%" />
                    <col width="*" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>
                            Date
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td>
                            <span class="clearable">
                                <input
                                    type="text"
                                    class="text_input w100"
                                    placeholder
                                    v-model="edit.REG_DT"
                                    readonly
                                    v-clearable
                                />
                            </span>
                        </td>
                        <th>
                            Register
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td>
                            <span class="clearable">
                                <input
                                    type="text"
                                    class="text_input w100"
                                    placeholder
                                    v-model="edit.REG_USER_ID"
                                    readonly
                                    v-clearable
                                />
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <th>Type
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td>
                            <select
                                class="slt_white w100p"
                                v-model="edit.TYPE1"
                                @change="edit.TYPE2 = ''"
                            >
                                <option value="Guide">Guide</option>
                                <option value="Bulletin">Bulletin</option>
                            </select>
                        </td>
                        <th>Subtype
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td>
                            <select
                                class="slt_white w100p"
                                ref="TYPE2G"
                                v-if="edit.TYPE1 === 'Guide'"
                                v-model="edit.TYPE2"
                                v-validation
                            >
                                <option value>Select Inquiry type</option>
                                <option value="Common">Common</option>
                                <option value="IMEI">IMEI</option>
                                <option value="Policy / Process">Policy / Process</option>
                                <option value="SW Tool">SW Tool</option>
                                <option value="Jig / Equipment">Jig / Equipment</option>
                                <option value="Training Material">Training Material</option>
                            </select>

                            <div v-if="edit.TYPE1 === 'Bulletin'" >
                                <select
                                    class="slt_white w49"
                                    ref="TYPE2B"
                                    v-model="edit.TYPE2"
                                >
                                    <option value>Select Inquiry type</option>
                                    <option
                                        v-for="item in bulletinType2List"
                                        :key="item"
                                        :value="item"
                                    >{{item}}</option>
                                </select>
                                <input
                                    class="text_input w49"
                                    type="text" v-model="edit.NTYPE2">
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            Urgency
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td>
                            <label class="radiobox-wrap mr10">
                                <input type="radio" name value="N" v-model="edit.URGENCY_YN" />
                                <i class="radio-icon"></i>
                                <em>Normal</em>
                            </label>
                            <label class="radiobox-wrap">
                                <input type="radio" name value="Y" v-model="edit.URGENCY_YN" />
                                <i class="radio-icon"></i>
                                <em class="txt_red">Urgency</em>
                            </label>
                        </td>
                        <th>
                            Need Translation
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td>
                            <label class="radiobox-wrap mr10">
                                <input type="radio" name value="Y" v-model="edit.NEED_REPROCESS" />
                                <i class="radio-icon"></i>
                                <em class="txt_red">Need</em>
                            </label>
                            <label class="radiobox-wrap">
                                <input type="radio" name value="N" v-model="edit.NEED_REPROCESS" />
                                <i class="radio-icon"></i>
                                <em>Not Need</em>
                            </label>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            Sort
                        </th>
                        <td>
                            <label class="radiobox-wrap mr10">
                                <input type="radio" name value="Y" v-model="edit.MMTTP" />
                                <i class="radio-icon"></i>
                                <em class="txt_red">Don't move to the top</em>
                            </label>
                            <label class="radiobox-wrap">
                                <input type="radio" name value="N" v-model="edit.MMTTP" />
                                <i class="radio-icon"></i>
                                <em>Move to the top</em>
                            </label>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            Title
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td colspan="3">
                            <span class="clearable">
                                <input
                                    type="text"
                                    class="text_input w100"
                                    ref="title"
                                    minlength="5"
                                    maxlength="200"
                                    v-model="edit.TITLE"
                                    v-validation
                                    v-clearable
                                />
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <th>Tag Info</th>
                        <td colspan="3">
                            <span class="clearable">
                                <input
                                    type="text"
                                    class="text_input w100"
                                    minlength="2"
                                    maxlength="200"
                                    v-model="edit.TAG_INFO"
                                    value
                                    v-clearable
                                />
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            User Level
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td colspan="3" class="userlevel">
                            <!--User Levec heckbox-->
                            <!--checkbox_all-->
                            <div class="check_wrap w260p">
                                <label class="checkbox-wrap mr5">
                                    <input
                                        type="checkbox"
                                        ref="checkboxUserLevelAll"
                                        :checked="checkedUserLevelList.length === allUserLevelList.length"
                                        @change="onUserLevelAllCheckboxChange($event)"
                                    />
                                    <i class="check-icon"></i>
                                </label>
                                <em>All</em>
                            </div>
                            <div
                                class="check_wrap w260p"
                                v-for="item in userLevelList"
                                :key="item.CODE_ID"
                            >
                                <label class="checkbox-wrap mr5">
                                    <input
                                        type="checkbox"
                                        :value="item.CODE_ID"
                                        v-model="checkedUserLevelList"
                                    />
                                    <i class="check-icon"></i>
                                </label>
                                <em>{{item.CODE_ID}}({{item.CODE_NAME}})</em>
                            </div>
                            <!--//User Level checkbox-->
                        </td>
                    </tr>
                    <tr>
                        <th>
                            Subsidary
                            <em class="txt_mandatory">*</em>
                            <span class="ico_pen" @click="selectSubsidiaryPopup">pen아이콘</span>
                        </th>
                        <td colspan="3">
                            <ul class="ul_list">
                                <li
                                    class="userlevel_txt"
                                    v-for="item in selectedSubsidiaryList"
                                    :key="item"
                                    @change="onCountryCheckboxChange($event)"
                                >{{item}}</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            Country
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td colspan="3" class="userlevel">
                            <div
                                v-if="availableCountryList.length === 0"
                            >
                                Please select subsidiary first.
                            </div>
                            <div class="check_wrap w260p" v-if="availableCountryList.length > 0">
                                <label class="checkbox-wrap mr5">
                                    <input
                                        type="checkbox"
                                        ref="checkboxCountryAll"
                                        :checked="checkedCountryList.length === availableCountryList.length"
                                        @change="onCountryAllCheckboxChange($event)"
                                    />
                                    <i class="check-icon"></i>
                                </label>
                                <em>All</em>
                            </div>
                            <div
                                class="check_wrap w260p"
                                v-for="item in availableCountryList"
                                :key="item.CODE_ID"
                            >
                                <label class="checkbox-wrap mr5">
                                    <input
                                        type="checkbox"
                                        :value="item.CDCODE"
                                        v-model="checkedCountryList"
                                    />
                                    <i class="check-icon"></i>
                                </label>
                                <em>{{item.CDDESC}}</em>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            Contents
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td colspan="3">
                            <cross-editor
                                editorId="bulletin"
                                :editorData="edit.CONTENT" />
                        </td>
                    </tr>
                    <tr v-if="!isLoading">
                        <th>Attachment</th>
                        <td colspan="3" class="no_padding">
                              <innorix-upload
                                id="innorixUpload"
                                name="innorixUpload"
                                uploadId="innorixUpload"
                                serviceType="hhpsvc"
                                :onlyUpload="false"
                                :attachList="fileList"
                                @files="setAttachFiles"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
            <!-- //detail -->
            <!-- page btn -->
            <div class="btn_wrap_full topLine">
                <a
                    href="javascript:"
                    class="btn_white"
                    @click="$router.push({name: 'hhpServiceBulletinView', query: {seq}})"
                >View</a>
                <div class="btn_right">
                    <a href="javascript:" class="btn_white" @click="btnSaveDraft()">{{ $t('BUTTON.GLOBAL.SAVEDRAFT') }}</a>
                    <a href="javascript:" class="btn_blue" @click="onSaveClick()">Save</a>
                </div>
            </div>
            <!-- //page btn -->
        </div>
    </div>
    <!-- contents -->
</template>

<script>
import Vue            from 'vue';
import { mapGetters } from 'vuex';

import axios from 'axios';
import qs from 'query-string';
import moment from 'moment';

import { SDLUtil, StringUtil, DateUtil } from '@/utils';
import refTitleFilter from '@/filters/refTitle';
import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';

import CrossEditor from '~c/CrossEditor';
import InnorixUpload from '~c/InnorixUpload';

import AnysvcApprovalPopup        from '~c/popup/AnysvcApprovalPopup';
import ApprovalHistoryPopup                 from '~c/popup/ApprovalHistoryPopup';
import KnowledgeTargetPopup from '~vb/knowledge/popup/KnowledgeTargetPopup';

import BlankPageTempPage from '/static/sample/CREATE_Template_04.html';

//anysvcmobile saveDraft api
const fetchSaveDraft = regForm => {
    // knowledgeId가 없는 경우 최초 생성 (KnowledgeId) -> 이후 업데이트
    let  api = `${SDLUtil.API_URL}/basis/anysvcmobile/svcBulletin/sbModifyProc.skp`;
    return axios.post( api, qs.stringify(regForm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } } );
};

export default {
    name: '',
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
        'cross-editor': CrossEditor,
       	'innorix-upload': InnorixUpload,
    },
    props: {
        seq: {
            type: String | Number,
            reqruied: true,
        },
    },
    computed: {
        getBlankTemplate() {
            return BlankPageTempPage;
        },
    },
    data() {
        return {
            isLoading: true,

            allUserLevelList: [],

            userLevelList: [],
            subsidiaryList: [],
            bulletinType2List: [],

            selectedSubsidiaryList: [],

            edit: {
                REG_DT: '',
                REG_USER_ID: '',
                URGENCY_YN: 'N',
                NEED_REPROCESS: 'Y',
                TYPE1: 'Guide',
                TYPE2: '',
                NTYPE2: '',
                CONTENT: '',
                TITLE: '',
                TAG_INFO: '',
                SEQ: '',
            },
            checkedUserLevelList: [],

            availableCountryList: [],
            availableCountryCodeList: [],
            checkedCountryList: [],

            guid: '', // 임의의 guid
            editorId: '', // CE id
            uploadId: '', // Innorix id
            onlyUpload: false, // Innorix upload only check

            fileList: [], // Attach files
            attachFileSeq: [], // Attach files
            delAttachFiles: [], // Delete attach files
            isRemove: false, // Attach remove flag
        };
    },
    created() {
        this.init();
    },
    mounted() {},
    methods: {
        async init() {
            SDLUtil.showLoadingBar(true);

            this.edit.REG_USER_ID = SDLUtil.getLoginedUserInfo().loginId;

            const dateFormat = moment().toMomentFormatString(localStorage.getItem('dateFormat') || 'MM.dd.yyyy');
            this.edit.REG_DT = moment().formatWithJDF(dateFormat);

            const data = await this.fetchInitData();
            if (SDLUtil.isErrorResponse(data)) {
                SDLUtil.alert({
                    title: 'Initial Loading Error',
                    msg: `${data.error.code} ${data.error.message}`,
                });
                return;
            }

            console.log('Init data', data);

            this.setInitData(data);

            // window.setTimeout(() => {
                this.isLoading = false;
            // }, 5000);

            SDLUtil.showLoadingBar(false);
        },

        fetchInitData() {
            const params = {
                seq: this.seq,
            };

            return (
                axios
                    // Loads data such as list of countries, etc...
                    .get(`${SDLUtil.API_URL}/basis/anysvcmobile/svcBulletin/sbModify.skp`, { params })
                    .then(res => {
                        console.log('SvcBulletin RESPONSE', res);
                        return res.data;
                    })
            );
        },
        setInitData(data) {
            this.bulletinType2List = data.bulletinType2List.map(item => item.TYPE2);

            this.userLevelList = data.userLevelLabelList;
            this.allUserLevelList = data.userLevelLabelList.map(item => item.CODE_ID);
            this.checkedUserLevelList = data.userLevelList.map(item => item.USER_LEVEL);

            this.subsidiaryList = data.subsidiaryList;
            this.selectedSubsidiaryList =
                data.selectedSubsidiaryList
                    .map(c => {
                        return data.subsidiaryList
                            .find(s => {
                                return c.CORP_NO === s.SUBSIDIARY_CD;
                            }).SUBSIDIARY_NM;
                    });

            this.fetchAvailableCountryList()
                .then(d => {
                    this.availableCountryList = d.countryList;
                });

            this.checkedCountryList = data.country.map(c => c.COUNTRY_CD);

            this.countryList = data.country.map(item => item.COUNTRY_NM).sort();

            const {
                title,
                reg_dt,
                reg_user_id,
                udt_dt,
                udt_user_id,
                need_reprocess,
                type1,
                type2,
                urgency_yn,
                content,
                tag_info,
                mmttp,
            } = data.view;

            this.edit = {
                TITLE: StringUtil.decodeXSS(refTitleFilter(title)),
                CONTENT: SDLUtil.stripHtml(content),
                REG_DT: reg_dt,
                REG_USER_ID: reg_user_id,
                UDT_DT: udt_dt,
                UDT_USER_ID: udt_user_id,
                NEED_REPROCESS: need_reprocess,
                TYPE1: type1,
                TYPE2: type2,
                NTYPE2: '',
                URGENCY_YN: urgency_yn,
                TAG_INFO: tag_info,
                TRAN: '',
                MMTTP: mmttp,
            };

            this.edit.TRAN = data.view.tran
                .split(',')
                .filter(i => i) // Remove empty item
                .map(item => item.replace(/ /g, ''))
                .join(', ');

            this.encToken = data.encToken;
            this.fileList = data.fileList.map(item => {
                item.ENC_TOKEN = data.encToken;
                item.ENC_ATTCH_FILE_SEQ = item.ATTCH_FILE_SEQ;
                return item;

            });
        },

        fetchAvailableCountryList() {
            const subsidiary = this.selectedSubsidiaryList
                .map(name => {
                    return this.subsidiaryList.find(item => item.SUBSIDIARY_NM === name).SUBSIDIARY_CD;
                })
                .join(',');

            const params = { subsidiary };
            return axios
                .get(`${SDLUtil.API_URL}/basis/anysvcmobile/notice/countryBySubsidiary.skp`, { params })
                .then(res => res.data)
                .catch(err => err.data);
        },

        onSaveClick() {
            this.save();
        },

        async save() {
        	if (!this.validateInput()) return;
			if(this.checkType1andType2()){
               	this.approvalPop();
			} else {
				this.sbModifyProc('save');
			}
        },

        btnSaveDraft(){
        	this.saveDraft();
        },

        async saveDraft(){
        	this.sbModifyProc('draft');
        },

        async  sbModifyProc(type){
        	const formData = this.prepFormData();
            // console.log('formData', formData);
			if(type === 'save'){
				formData.STATUS = 'S';
				formData.CHANGE_TYPE = 'save';
			} else if(type === 'draft'){
				formData.STATUS = 'P';
				formData.CHANGE_TYPE= 'draft';
			} else if (type === 'update'){
				formData.CHANGE_TYPE= 'update';
			}
            SDLUtil.showLoadingBar(true);

            const data = await SDLUtil.postForm('/basis/anysvcmobile/svcBulletin/sbModifyProc.skp', formData);

            SDLUtil.showLoadingBar(false);

            if (SDLUtil.isErrorResponse(data)) {
                SDLUtil.alert({
                    title: 'Error while Saving!',
                    msg: `${data.error.code} ${data.error.message}`,
                });
                return;
            }else{
            	const seq = formData.seq;
            	this.$router.push({name: 'hhpServiceBulletinView', query: {seq}})
            }
        },
        approvalPop() {
        	let that = this;
            		// 결재 팝업 오픈
                    SDLUtil.show(
                        AnysvcApprovalPopup,
                        {
                            title:           that.edit.TITLE,
                            guideType:       'ALL',  //  A: 로 하드코딩.
                            prdCategoryCd1:  'D',  // D: Mobile,  B: Computer
                            // service  bulletin approvel
                            serviceBulletinYn: 'SB',
                            workTable:       'ANYSVC_KNOWLEDGE',
                            workColumn:      'SEQ',
                            workKey:         that.seq,  // 결재 테이블에 키값 연결
                            rtnFunc:  (v) => {
                                if(v) that.sbModifyProc('update');
                            }
                        },
                        { height: 'auto' }
                    );
        },

        validateInput() {
            if (this.edit.TYPE1 === 'Bulletin' && !this.edit.TYPE2 && !this.edit.NTYPE2) {
                SDLUtil.alert({
                    title: 'Invalid input',
                    msg: 'Please select a subtype.',
                    onOkEvt: () => {
                        if (this.edit.TYPE1 === 'Guide') {
                            this.$refs.TYPE2G.focus();
                        } else {
                            this.$refs.TYPE2B.focus();
                        }
                    },
                });
                return false;
            }

            if (this.edit.TYPE1 === 'Guide' && !this.edit.TYPE2) {
                SDLUtil.alert({
                    title: 'Invalid input',
                    msg: 'Please select a subtype.',
                    onOkEvt: () => {
                        if (this.edit.TYPE1 === 'Guide') {
                            this.$refs.TYPE2G.focus();
                        } else {
                            this.$refs.TYPE2B.focus();
                        }
                    },
                });
                return false;
            }

            if (!this.edit.TITLE.trim() || this.edit.TITLE.length < 5) {
                SDLUtil.alert({
                    title: 'Invalid input',
                    msg: 'Title is required.',
                    onOkEvt: () => this.$refs.title.focus(),
                });
                return false;
            }

            if (this.checkedUserLevelList.length === 0) {
                SDLUtil.alert({
                    title: 'Invalid input',
                    msg: 'At least 1 user level needs to be selected.',
                });
                return false;
            }

            if (this.checkedCountryList.length === 0) {
                SDLUtil.alert({
                    title: 'Invalid input',
                    msg: 'At least 1 country needs to be selected.',
                });
                return false;
            }
            return true;
        },

        prepFormData() {
            const countryCodeList = this.selectedSubsidiaryList;

            const CEblankTxt = '<p><br></p>';
            const content = window.bulletin.GetBodyValue();
            if (content === CEblankTxt) {
                //invalid
            }

            //alert(this.checkedCountryList.join(','));
            //alert(this.availableCountryList.join(','));
            const params = {
                seq: this.seq,
                TITLE: this.edit.TITLE,
                TYPE1: this.edit.TYPE1,
                TYPE2: this.edit.TYPE2,
                TAG_INFO: this.edit.TAG_INFO,
                URGENCY_YN: this.edit.URGENCY_YN,
                REG_USER_ID: this.edit.REG_USER_ID,
                REG_DT: this.edit.REG_DT,
                // SUBSIDIARY: this.edit.,
                COUNTRY_VALUE_SPLIT: this.checkedCountryList.join(','),
                COUNTRY_TEXT_SPLIT: this.checkedCountryList
                    .map(code => this.availableCountryList.find(country => country.CDCODE === code).CDDESC)
                    .join(','),
                USER_LEVEL_SPLIT: this.checkedUserLevelList.join(','),
                NEED_REPROCESS: this.edit.NEED_REPROCESS,
                CONTENT: content,
                MMTTP: this.edit.MMTTP,
                attachFileSeq: this.fileList.map(item => item.attachFileSeq),
                STATUS:this.edit.status,
            };

            if (this.edit.TYPE1 === 'Bulletin' && this.edit.NTYPE2 !== '') {
                params.TYPE2 = this.edit.NTYPE2;
            }

            return params;
        },

        submit(formData) {
            return SDLUtil.postForm('/basis/anysvcmobile/svcBulletin/sbRegisterProc.skp', formData)
                .then(res => {
                    // console.log('POST FORM RESULT =>> ', res);
                    return res.data;
                })
                .catch(err => {
                    Vue.$log.error('POST FORM ERROR =>> ', err);
                    return err.data;
                });
        },

        selectSubsidiaryPopup() {
            SDLUtil.show(
                KnowledgeTargetPopup,
                {
                    selTargetList: this.selectedSubsidiaryList,
                    rtnFunc: this.onSelectSubsidiaryList,
                },
                { height: 'auto' },
            );
        },

        async onSelectSubsidiaryList(list = []) {
            // Subsidiary Target popup 에서 받아온 리스트를 sort 하여 답는다.
            this.selectedSubsidiaryList = list.sort();
            const data = await this.fetchAvailableCountryList();
            this.availableCountryList = data.countryList;
           // console.log('countryList', this.availableCountryList);
           //console.log('checkedCountryList', this.checkedCountryList);
		   this.availableCountryCodeList = this.availableCountryList.map(country => country.CDCODE);
           //console.log('availableCountryList', this.availableCountryCodeList);
           this.checkedCountryList = this.intersect(this.checkedCountryList, this.availableCountryCodeList);
           //console.log('checkedCountryList', this.checkedCountryList.join(','));
        },

        intersect(arr1, arr2) {
       	  return arr1.filter(item => arr2.includes(item));
       	},

        onUserLevelAllCheckboxChange(e) {
            // console.log('change e', e);
            this.checkedUserLevelList = e.target.checked ? this.allUserLevelList : [];
        },
        onCountryAllCheckboxChange(e) {
            // console.log('change e', e);
            this.checkedCountryList = e.target.checked ? this.availableCountryList.map(item => item.CDCODE) : [];
        },
        onCountryCheckboxChange(e) {
            // console.log('change e', e);
            this.checkedCountryList = e.target.checked ;
        },

        setAttachFiles(val) {
            Vue.$log.info('▶ InnorixUpload.vue -> BulletinEdit.vue / files : ', val);
            this.fileList = val.fileList || [];
            this.delAttachFiles = val.delFileList || [];
            this.isRemove = val.isRemove || true;
        },

        deleteFile(fileSeq, fileName) {
            // console.log('SEQ: ', fileSeq)
            SDLUtil.confirm({
                title: '[WARNING] Delete File?',
                msg: 'This action will delete file(s) on server.<br>Do you want to continue?<br><br>File Name: ' + fileName,
                okLabel: 'Delete',
                cancelLabel: 'Cancel',
                onOkEvt: () => {
                    this.removeAttach(fileSeq);
                },
                onCancelEvt: () => {},
            });
        },

        async removeAttach(attachFileSeq) {
            await SDLUtil.deleteAttach(attachFileSeq, this.encToken);
            this.fileList = this.fileList.filter(item => {
                return item.ATTCH_FILE_SEQ !== attachFileSeq;
            });
        },
      //Check whether submission is required for approval
    	checkType1andType2(){
    		if(this.edit.TYPE1=== 'Guide' && (this.edit.TYPE2 ==='Common'  || this.edit.TYPE2 ==='IMEI' || this.edit.TYPE2 ==='SW Tool' || this.edit.TYPE2 ==='Jig / Equipment' || this.edit.TYPE2 ==='Training Material')){
    			return false;
    		} else {
    			return true;
    		}
    	},
    },

};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/svcBulletin/BulletinEdit.vue